import z from "zod";
import { AssetIdSchema, LabelIdSchema } from "./idTypes";
import { TenancySchema } from "./tenancyTypes";
import { AuditMetaSchema } from "./auditMetaTypes";

const AssetLifecycleStateSchema = z.enum([
  "AWAITING_UPLOAD",
  "UPLOADED",
  "QUEUED_FOR_PROCESSING",
  "PROCESSING",
  "READY",
  "FAILED",
  "REPROCESSING",
  "ARCHIVED",
  "QUARANTINED",
  "DELETE_REQUESTED",
  "DELETED",
  "TOO_MANY_REQUESTS",
]);

export type AssetLifecycleState = z.infer<typeof AssetLifecycleStateSchema>;

export const AssetSchema = z
  .object({
    id: AssetIdSchema,
    displayName: z.string(),
    description: z.string(),
    fileName: z.string(),
    contentType: z.string(),
    labels: z.array(LabelIdSchema).optional(),
    lifecycleState: AssetLifecycleStateSchema,
  })
  .extend(TenancySchema.shape)
  .extend(AuditMetaSchema.shape);

export type Asset = z.infer<typeof AssetSchema>;
